<template>
  <div class="reward-bubble" :class="bubbleClass" aria-hidden="true">
    <div class="reward-bubble__pill">
      <img
        v-if="showIcon"
        src="@/assets/images/icon_benefit_bonus_normal.png"
        alt=""
        class="reward-bubble__icon"
      />
      <span class="reward-bubble__text">{{ text }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  text: {
    type: String,
    required: true
  },
  variant: {
    type: String,
    default: 'login-header',
    validator: (value) => ['login-sheet', 'login-header', 'tab'].includes(value)
  }
})

const showIcon = computed(() => props.variant !== 'tab')
const bubbleClass = computed(() => `reward-bubble--${props.variant}`)
</script>

<style lang="scss" scoped>
.reward-bubble {
  position: relative;
  display: inline-flex;
  pointer-events: none;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    width: 0;
    height: 0;
  }
}

.reward-bubble__pill {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
}

.reward-bubble__icon {
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}

.reward-bubble__text {
  font-weight: 700;
  line-height: 1;
  color: #ffffff;
  white-space: nowrap;
}

.reward-bubble--tab {
  .reward-bubble__pill {
    height: 18px;
    padding: 0 8px;
    border-radius: 6px;
    background: #de2c92;
  }

  .reward-bubble__text {
    font-size: 10px;
  }

  &::after {
    left: 50%;
    transform: translateX(-50%);
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #de2c92;
  }
}

.reward-bubble--login-header {
  .reward-bubble__pill {
    height: 20px;
    padding: 0 10px;
    border-radius: 10px;
    background: linear-gradient(90deg, #f59c21 0%, #de2c92 100%);
  }

  .reward-bubble__icon {
    width: 17px;
    height: 12px;
  }

  .reward-bubble__text {
    margin-left: 5px;
    font-size: 8px;
    font-weight: 600;
  }

  &::after {
    right: 14px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #de2c92;
  }
}

.reward-bubble--login-sheet {
  .reward-bubble__pill {
    height: 24px;
    padding: 0 10px;
    border-radius: 12px;
    background: linear-gradient(90deg, #f59c21 0%, #de2c92 100%);
  }

  .reward-bubble__icon {
    width: 20px;
    height: 14px;
  }

  .reward-bubble__text {
    margin-left: 6px;
    font-size: 10px;
  }

  &::after {
    right: 14px;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #de2c92;
  }
}
</style>
